import React from 'react';
import ResponsiveWrapper from '../../../components/ResponsiveWrapper';
import ControlInfo from './index';
import MobileControlInfo from './MobileControlInfo';

const ResponsiveControlInfo = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileControlInfo />}
      desktop={<ControlInfo />}
    />
  );
};

export default ResponsiveControlInfo;